module.exports = __webpack_public_path__ + "img/ico_libao.ba6289a1.png";